import React from 'react'

function ThanksFeedback() {
  return (
    <div className='thanks-feedback-bg'>
        <div className='thanks-feedback-main'>
            <div className='feedback-done-icon'>   <div><i class="fa-solid fa-check"></i></div> </div>
            <div>Thank You </div>
            <p>Your feedback helps us grow. We’re grateful you took the time to share it.</p>
        </div>
    </div>
  )
}

export default ThanksFeedback